// Misc functions
const { $ } = window;

$(() => {
  // Scroll tab selector to currently select tab
  const $tabSelector = $('.tab-links').first();

  if ($tabSelector.length) {
    const { hash } = window.location;
    $tabSelector.find(`a[href='${hash}'`).addClass('active');
    const $activeTab = $tabSelector.find('a.active').parent('li');
    if ($activeTab.length) {
      $activeTab.closest('.tab-links').animate({ scrollLeft: $activeTab.position().left });
    }
  }

  const $scheduleTabs = $('.schedule-channel-tabs').first();
  if ($scheduleTabs.length) {
    const $activeTab = $scheduleTabs.find('li.active');
    const { left } = $activeTab.position();
    $activeTab.closest('.schedule-channel-tabs').animate({ scrollLeft: left - (parseInt($activeTab.css('paddingLeft'), 10)) });
  }
});
